export default {
    methods: {
        formatMoney(val) {
            if (typeof val === 'string' || val instanceof String) {
                val = val.replace(/,/g, '');
            }

            return val && (parseInt(val) < parseFloat(val))
                ? (parseFloat(val) || 0).toFixed(2)
                : val;
        },

        formatMoneyToString(value) {
            if (! value) {
                return;
            }

            let formatted_value = value.toString().replace(/,/g, '');
            let decimal_portion = formatted_value.split('.')[1];

            if (typeof decimal_portion === 'undefined') {
                decimal_portion = '';
            } else {
                decimal_portion = '.' + decimal_portion;
            }

            return formatted_value && ! isNaN(formatted_value)
                ? (new Intl.NumberFormat('en-EN')).format(parseInt(formatted_value)) + decimal_portion
                : null;
        },

        moneyVal(val) {
            let formatted = parseFloat(this.formatMoney(val));

            return isNaN(formatted) ? 0 : formatted;
        },
    },
}
